import { render, staticRenderFns } from "./Organization.vue?vue&type=template&id=d01725f4&scoped=true&"
import script from "./Organization.vue?vue&type=script&lang=ts&"
export * from "./Organization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01725f4",
  null
  
)

export default component.exports